import { supabaseClient } from "supabase/supabase";

export const deleteVenue = async ({ uid }: { uid: string }) => {
  const query = supabaseClient.from("venues").delete().eq("uid", uid);
  const { error } = await query;
  if (error) {
    throw error;
  }
  return null;
};
